import { useQuery } from "@tanstack/react-query";
import { base44 } from "@/api/base44Client";

// ✅ Helper: Guarantees we always get an array, even if the API returns null/undefined
const ensureArray = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

export function useSalesQueries() {
  const { data: salesData } = useQuery({
    queryKey: ["sales"],
    queryFn: () => base44.entities.Sale.list("-created_date"),
    initialData: [],
  });

  const { data: clientsData } = useQuery({
    queryKey: ["clients"],
    queryFn: () => base44.entities.Client.list(),
    initialData: [],
  });

  const { data: apartmentsData } = useQuery({
    queryKey: ["apartments"],
    queryFn: () => base44.entities.Apartment.list(),
    initialData: [],
  });

  const { data: reservationsData } = useQuery({
    queryKey: ["reservations"],
    queryFn: () => base44.entities.ApartmentReservation.list(),
    initialData: [],
  });

  const { data: paymentsData } = useQuery({
    queryKey: ["payments"],
    queryFn: () => base44.entities.Payment.list("-payment_date"),
    initialData: [],
  });

  const { data: receiptsData } = useQuery({
    queryKey: ["receipts"],
    queryFn: () => base44.entities.Receipt.list(),
    initialData: [],
  });

  const { data: defaultedSalesData } = useQuery({
    queryKey: ["defaultedSales"],
    queryFn: () => base44.entities.DefaultedSale.list("-defaulted_date"),
    initialData: [],
  });

  return {
    sales: ensureArray(salesData),
    clients: ensureArray(clientsData),
    apartments: ensureArray(apartmentsData),
    reservations: ensureArray(reservationsData),
    payments: ensureArray(paymentsData),
    receipts: ensureArray(receiptsData),
    defaultedSales: ensureArray(defaultedSalesData),
    loadingSales: !salesData,
    loadingPayments: !paymentsData,
  };
}